/* global localStorage */
import types from './types'
import firebase from 'firebase'

const db = firebase.database();
const auth = firebase.auth();

export const getCurrentUser = () => {

  return (dispatch) => {

    auth.onAuthStateChanged((user) => {
      getModelUserByUserAndDispatch(dispatch, user);
    });
  }
}

function getModelUserByUserAndDispatch(dispatch, user) {
  if (!user) {
    dispatch({ type: types.GET_CURRENT_USER, payload: null });
    return
  }

  try {
    const currentUser = JSON.parse(localStorage.getItem('currentModelUser'));
    if (currentUser && currentUser.id === user.uid) {
      dispatch({ type: types.GET_CURRENT_USER, payload: currentUser });
    }
  } catch (e) {}

  db.ref('users').child(user.uid).once('value').then((snapshot) => {
    const result = snapshot.val();
    localStorage.setItem('currentModelUser', JSON.stringify(result));
    dispatch({ type: types.GET_CURRENT_USER, payload: result });
  });
}



// WEBPACK FOOTER //
// ./src/action/index.js